import { GuardMes } from "@/features/guardme/guardmes";

export const Route = createFileRoute({
  component: GuardMes,
});
